import { atom } from 'jotai';
import { getUserPermissionsFromLocal } from 'utils/js/userPermissions';

const cached = getUserPermissionsFromLocal();

export const userPermissions = atom({
  isReady: cached != null,
  permissions: cached ?? [],
});
